<template>
  <el-container class="up-main">
      <el-aside width="211px">
          <left-menu :active="4"></left-menu>
      </el-aside>
      <el-main class="u-main">
        <div class="bcont">
          <el-form ref="form" :model="form" label-position="left" label-width="110px" :rules="cRules"  >
            <el-form-item label="原始密码" prop="oldPassword">
                <el-input type="password" v-model="form.oldPassword" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="新密码" prop="newPassword">
                <el-input type="password" v-model="form.newPassword" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="确认密码" prop="checkPass">
                <el-input type="password" v-model="form.checkPass" autocomplete="off"></el-input>
            </el-form-item>
          </el-form>

          <div style="    text-align: center;">
            <el-button class="s-but" type="primary" @click="submitForm('form')" :loading="butLoading">提 交</el-button>
            <el-button class="s-but" @click="resetForm('form')">重置</el-button>
          </div>

        </div>
        
      </el-main>
  </el-container>
</template>

<script> 
import leftMenu from './components/leftMenu'
import { encrypt, decrypt } from '@/utils/jsencrypt'
export default {
  name: "cIndex",
  components: {
    leftMenu 
  },
  data() {
    var validateNewPass = (rule, value, callback) => {
            if (value === '') {
              callback(new Error('请输入新密码'));
            } else if (!this.checkInput(this.form.newPassword) ) {
              callback(new Error('请输入6~16位数字、字母的密码'));
            } else {
              callback();
            }
        };
         var validatePass = (rule, value, callback) => {
            if (value === '') {
              callback(new Error('请再次输入密码'));
            } else if (value !== this.form.newPassword) {
              callback(new Error('两次输入密码不一致!'));
            } else {
              callback();
            }
        };
    return {
      form:{
        newPassword: '',
        checkPass: '',
        oldPassword: '',
        username :localStorage.getItem('mobile')
      },
      cRules:{
        newPassword: [
          { validator: validateNewPass, trigger: 'blur' }
        ],
        checkPass: [
          { validator: validatePass, trigger: 'blur' }
        ],
        oldPassword: [
          { required: true, message: '请输入密码', trigger: 'blur' }
        ]
      },
      butLoading:false
    }
  },
  created() {
    
  },
  methods: {
     submitForm(formName) {
            let _this = this
            this.$refs[formName].validate((valid) => {
              if (valid) {
            
                _this.form.newPassword = encrypt(_this.form.newPassword)
                _this.form.oldPassword = encrypt(_this.form.oldPassword)

              
                    _this.form.username = sessionStorage.getItem('account') 
                    _this.$api.api.changeOrganPasswordUC(_this.form).then((data) => {
                        if(data.code == 200){
                            _this.$message({
                              message: data.msg,
                              type: 'success'
                            });
                            setTimeout(function(){
                                _this.$router.go(-1)
                            },)
                        }else{
                            _this.$message.error(data.msg);
                        }
                    })

                
              } else {
                console.log('error submit!!');
                return false;
              }
            });
        },
        resetForm(formName) {
            this.$refs[formName].resetFields();
        },
        
        checkInput(value) {
           
            var uPattern = /^([\x21-\x7e]|[a-zA-Z0-9]){6,16}$/g;
            return uPattern.test(value);
        },
  }
}
</script>

<style lang="less">
@import '../style.less';
.bcont{width:500px;margin:50px auto;}
</style>
